import api from './api'

export const logout = () => api.post('user/logout')

export const login = params => api.post('user/login', params)

export const wechatLogin = params => api.post('user/teacher/wechat/login',
  Object.assign({ platform: 'web' }, params))

export const own = () => api.get('user/own', { timestamp: new Date().getTime() })

export const check = user => user && user.role === 'teacher'

export default {
  logout,
  login,
  wechatLogin,
  own,
  check,
}
